import { render, staticRenderFns } from "./KgjtWebsiteOnlineMessage.vue?vue&type=template&id=06e6a8c8&scoped=true&"
import script from "./KgjtWebsiteOnlineMessage.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteOnlineMessage.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteOnlineMessage.vue?vue&type=style&index=0&id=06e6a8c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6a8c8",
  null
  
)

export default component.exports